<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-4 flex w-full items-end">
        <div class="w-1/2 pr-4">
          <b-form-radio
            v-model="selected"
            class="custom-control-inline font-semibold radio-btn-fix"
            name="some-radios"
            value="A"
          >
            From</b-form-radio
          >

          <base-input class="div-mb-0">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pr-4">
          <b-form-radio
            v-model="selected"
            class="custom-control-inline font-semibold radio-btn-fix"
            name="some-radios"
            value="A"
          >
            To</b-form-radio
          >
          <base-input class="div-mb-0">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pl-12">
          <base-button
            filled
            type="success"
            class="px-10 py-3"
            @click="toggleDetails(true)"
            >Search</base-button
          >
        </div>
      </div>

      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="ClickReportData"
        >
          <el-table-column label="Type" min-width="120px" prop="type" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.type }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Campaign ID"
            min-width="150px"
            prop="campaignid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.campaignid }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Date" min-width="150px" prop="date" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.date }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Number	"
            min-width="150px"
            prop="totalnumber	"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.totalnumber }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Clicked"
            min-width="150px"
            prop="totalclicked"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.totalclicked }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Action"
            min-width="100px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import ClickReportData from "./ClickReportData";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
  },
  data() {
    return {
      ClickReportData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
